import {
  Activity,
  Award,
  BookOpen,
  Briefcase,
  Code,
  Cpu,
  CreditCard,
  DownloadCloud,
  FileSpreadsheet,
  Gamepad2,
  GraduationCap,
  Headphones,
  Lock,
  Monitor,
  MoreHorizontal,
  Package,
  Palette,
  RefreshCw,
  Settings,
  ShieldCheck,
  Smartphone,
  TrendingUp,
  Unlock,
  Waves,
  Wrench,
  Zap,
} from "lucide-react";

const ICONS = {
  monitor: Monitor,
  "file-spreadsheet": FileSpreadsheet,
  "shield-check": ShieldCheck,
  palette: Palette,
  wrench: Wrench,
  unlock: Unlock,
  "gamepad-2": Gamepad2,
  "refresh-cw": RefreshCw,
  "download-cloud": DownloadCloud,
  headphones: Headphones,
  activity: Activity,
  settings: Settings,
  briefcase: Briefcase,
  package: Package,
  "credit-card": CreditCard,
  smartphone: Smartphone,
  waves: Waves,
  lock: Lock,
  zap: Zap,
  award: Award,
  "book-open": BookOpen,
  code: Code,
  cpu: Cpu,
  "trending-up": TrendingUp,
  "more-horizontal": MoreHorizontal,
  "graduation-cap": GraduationCap,
};

export function DynamicIcon({ name, className = "h-5 w-5", strokeWidth = 2 }) {
  const Component = ICONS[name] || Package;
  return <Component className={className} strokeWidth={strokeWidth} />;
}

export default ICONS;
